var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcArrowDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.4142 5.03551L2.41418 5.03552L2.417 5.03828L7.767 10.2633L8.00101 10.4918L8.23393 10.2622L13.5839 4.98716L13.5839 4.98717L13.5856 4.98551C13.6804 4.89068 13.8194 4.89068 13.9142 4.98551C14.0087 5.08005 14.009 5.21846 13.915 5.31326C13.9148 5.31354 13.9145 5.31382 13.9142 5.3141L8.16628 10.962L8.16627 10.962L8.1642 10.9641C8.06789 11.0604 8.02303 11.0665 7.9999 11.0665C7.94098 11.0665 7.88993 11.052 7.82015 10.9989L2.08477 5.36327C1.99078 5.26846 1.99106 5.13005 2.0856 5.03551C2.18043 4.94068 2.31937 4.94068 2.4142 5.03551Z",
    fill: "#637381",
    stroke: "#637381",
    strokeWidth: 0.666667
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowDown);
export default __webpack_public_path__ + "static/media/ic_arrow_down.2e0b48cc37d5377d995e0a6f623995e9.svg";
export { ForwardRef as ReactComponent };